<script>
  import ModalView from '../components/modal-view'
  import ModalViewSp from '../components/modal-view-sp'
  import ModalDialogSp from '../components/modal-dialog-sp'
  import DailyHint from '../components/daily-hint'
  import DailyHintSp from '../components/daily-hint-sp'
  import AnnouncementModal from '../components/announcement-modal'
  import AnnouncementModalSp from '../components/announcement-modal-sp'

  export default {
    template: '#modal-wrapper-template',
    name: 'ModalWrapper',
    props: ['modalProps'],
    data () {
      return {
        showModal: false,
        currentModal: null,
        isDialog: false,
        chidlren: null,
      }
    },
    mounted () {
      this.chidlren = this.getChildren()
      this.openNextModal()
      
    },
    methods: {
      openModalViewByElementId(elementId) {
        if (this.currentModal) {
          this.currentModal.setReady()
          this.currentModal = null
        }
        this.currentModal = this.chidlren.find((modalView) => modalView.id === elementId)
        if (this.currentModal) {
          this.showModal = this.currentModal.showModal = true
          this.isDialog = this.currentModal.isDialog
        }
      },

      closeModalView () {
        if (this.currentModal) {
          this.currentModal.closeModal(true)
          this.currentModal = null
        }

        // 次のモーダルを開く
        this.openNextModal()
      },

      openNextModal () {
        if (this.currentModal) {
          return
        }

        // ready な modal があれば表示する
        this.currentModal = this.chidlren.find((modalView) => modalView.ready && !modalView.closed)

        if (this.currentModal) {
          this.showModal = this.currentModal.showModal = true
          this.isDialog = this.currentModal.isDialog
        } else {
          this.showModal = false
        }
      },
      getChildren() {
        const children = []
        const keys = Object.keys(this.$refs)
        for ( let i = 0; i < keys.length; i++) {
          const key = keys[i]
          children.push(this.$refs[key])
        }
        return children
      },
    },

    watch: {
    },
    components: {
      'modal-view': ModalView,
      'modal-view-sp': ModalViewSp,
      'modal-dialog-sp': ModalDialogSp,
      'daily-hint': DailyHint,
      'daily-hint-sp': DailyHintSp,
      'announcement-modal': AnnouncementModal,
      'announcement-modal-sp': AnnouncementModalSp
    }
  }
</script>
